
export default {
  props: {
    url: {
      type: String,
      required: true,
    },

    videoThumbnail: {
      type: String,
      required: true,
    },

    embeddable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      videoIsReady: false,
      playing: false,
    }
  },

  computed: {
    videoId() {
      const match = /vimeo\.com\/(\d+)/.exec(this.url)
      return match[1]
    },
  },

  methods: {
    playVideo() {
      if (this.embeddable) {
        this.$refs.vimeo.play()
      } else {
        window
          .open(`https://vimeo.com/${this.videoId}?autoplay=true`, '_blank')
          .focus()
      }
    },
  },
}
